import React, { memo } from "react";
import PropTypes from "prop-types";
import { WalletMain, WalletNavSlot, WalletWrapper } from "./elements";

export const BettoWalletContentWrapper = memo(({ children }) => (
	<WalletWrapper>
		<WalletMain>{children}</WalletMain>
		<WalletNavSlot id="navigation-btns" />
	</WalletWrapper>
));

BettoWalletContentWrapper.displayName = "BettoWalletContentWrapper";

BettoWalletContentWrapper.propTypes = {
	children: PropTypes.node,
};
